/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { Box, InputBase, IconButton, useMediaQuery } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import dashboardStyles from '../Dashboard.style';
import { useDispatch } from 'react-redux';
import { dbSearchTxt } from '../Dashboard.actions';

function SearchReports() {
	const isSmallScreen = useMediaQuery('(max-width:600px)');
	const classes = dashboardStyles({ isSmallScreen });
	const [searchTxt, setSearchTxt] = useState('');
	const dispatch = useDispatch();

	const handleSearch = (text) => {
		setSearchTxt(text);
		dispatch(dbSearchTxt(text));
	};

	return (
		<Box className={classes.search}>
			<Box className={classes.searchIcon}>
				<SearchIcon />
			</Box>
			<InputBase
				value={searchTxt}
				id="search-field"
				onChange={(e) => handleSearch(e.target.value)}
				placeholder="Search report name"
				classes={{
					input: classes.input
				}}
				inputProps={{ 'aria-label': 'search' }}
				disabled={false}
			/>
			{searchTxt !== '' && (
				<Box className={classes.crossIcon}>
					<IconButton
						aria-label="Clear search"
						id="clear"
						onClick={() => {
							setSearchTxt('');
							dispatch(dbSearchTxt(''));
						}}>
						<CloseIcon fontSize="medium" />
					</IconButton>
				</Box>
			)}
		</Box>
	);
}

SearchReports.propTypes = {
	// disabled: PropTypes.bool
};

export default React.memo(SearchReports);
